import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/adquisiciones/notas-entrada/{id}', documento: 'adquisiciones', acceso: 'sesion', filas: ['051'],
  cita: 'Areas/Adquisiciones/Controllers/NotasEntradaController.cs',
} satisfies RutaProd;
